export { default } from './toPairs.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/entries.js
// module id = 603
// module chunks = 41